import React, {useEffect} from 'react';
import Container from "../ui/container/container";
import parse from "html-react-parser";
import data from '../db-local/db.json'
import FooterComponent from "../components/footer.component";
import {Link} from "react-router-dom";

const PolicyPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <Container className={'first'}>
                <div className={'topHeader'}>
                    <div className={'nav'}>
                        <Link to={'/'}><img src={process.env.PUBLIC_URL + '/assets/img/logo.svg'} alt={'logo'}/></Link>
                        <Link to={'/'}>Back to home</Link>
                    </div>
                    <div className={'img'}><img src={process.env.PUBLIC_URL + '/assets/img/banner.png'}
                                                alt={'banner'}/></div>
                </div>

                <h1 className={'header'}>{parse(data.policy.title)}<span className={'point'}>.</span></h1>
                <div className={'hr'}/>
                {
                    parse(data.policy.subTitle)
                }
                {
                    parse(data.policy.description)
                }
            </Container>
            <Container className={'policy'}>
                <div className={'policyContent'}>
                    {
                        parse(data.policy.content)
                    }
                </div>
            </Container>
            <Container style={{marginBottom: 0, height: "25rem"}}>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2883.585459018898!2d-79.35112932320901!3d43.71916327109914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cddf955a393f%3A0x14da8e749f905453!2zMzAgSW5uIE9uIFRoZSBQayBEciwgTm9ydGggWW9yaywgT04gTTNDIDBQNywg0JrQsNC90LDQtNCw!5e0!3m2!1sru!2sru!4v1749646614369!5m2!1sru!2sru"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade" style={{width: "100%", border: "none", height: "25rem"}}></iframe>
            </Container>
            <Container className={'four'}>
                <h2 className={'header'}>{data.data[3].title}</h2>
                <div className={'description'}>{data.data[3].description ? parse(data.data[3].description) : ''}</div>
                <FooterComponent item={data.data[3]}/>
            </Container>
        </>

    );
};

export default PolicyPage;